import PropTypes from 'prop-types';
import { Children } from 'react';

const getDisplayName = component =>
  component.displayName || component.name || 'Unknown';

export const DTIcon = (props, propName, componentName) => {
  const prop = props[propName];

  let error = null;

  Children.forEach(prop, child => {
    if (getDisplayName(child.type) !== 'Icon') {
      error = new Error(
        `\`${componentName}\` only accepts children of type \`Icon\`.`,
      );
    }
  });

  return error;
};

DTIcon.isRequired = (props, propName, componentName) =>
  props[propName] == null
    ? new Error(`${propName} is required in \`${componentName}\``)
    : DTIcon(props, propName, componentName);

export const FAIcon = PropTypes.shape({
  icon: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.any),
      PropTypes.number,
      PropTypes.string,
    ]),
  ).isRequired,
  iconName: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
});

export const HeadingLevel = PropTypes.oneOf([1, 2, 3, 4, 5, 6]);
